import React from 'react';

const ActivitiesPark = () => {
  return (
    <section id="activities-park">

      <h1>Parkgondozás, köztisztaság</h1>

      <div id="activities-park-columns">

        <div id="activities-park-left">

        </div>

        <div id="activities-park-right">

          <header>

            <div>
              <h2>Üzletágvezető:</h2>
              <ul>
                <li>Ponyokai Bálint</li>
              </ul>
            </div>

            <div>
              <h2>Elérhetőség:</h2>
              <ul>
                <li><a href="tel: +36 70/610-1644">70/610-1644</a></li>
              </ul>
            </div>

          </header>

          <p className="no-indent">
            Kft-nk a városközpontban található kb. 60.000 m² zöld felületnek a gondozását, ápolását, a gyepfelületek folyamatos nyírását, takarítását, a közterületeken lévő virágágyások telepítését, szakszerű gondozását, az önkormányzattal egyeztetve évelő fák pótlását, telepítését végzi. 
          </p><p>
            A város és önmagunkkal szembeni elvárásoknak akarunk megfelelni.
          </p><p>
            2012-ben átadott szálloda és fürdőcentrum, olyan városközponti kép kialakítását követeli meg tőlünk, mely egy fürdővárossá válás folyamatát elősegíti. 
          </p><p>
            A virágágyások kialakításánál, növények megválasztásánál szakítani akarunk és kell is az évtizedek óta bevett szokásokkal. Ezen törekvésünket a város-vezetéssel folyamatosan egyeztetjük. 
          </p><p>
            Feltett szándékunk, hogy egy fürdővárosoktól elvárható virágos város-központot, illetve városképet alakítsunk ki. 
          </p><p>
            A városközpontban 2014-2015-ben megvalósult beruházások jelentős mértékben átformálták a parkgondozási feladatainkat. 
          </p><p>
            2018. évben megvalósult SÜSÜ játszótér és Erzsébet liget megújítása kapcsán jelentős többletfeladat hárult ránk.
          </p>
          <br/>
          <p className="no-indent">
            Ezen tevékenységhez szorosan kapcsolódik a köztisztasági munkák végzése. A feladatot a vállalkozási szerződés mellékletében rögzített helyeken, módokon és gyakorisággal végezzük. 
          </p><p>
	          A munkavégzés során tapasztaljuk, hogy a köztéri hulladéktárolókat kommunális hulladékok tárolására használja a lakosság, a gondok megoldásához kértük az önkormányzat segítségét (közterület felügyelők ellenőrzés).
          </p>
          <br/>
          <p className="no-indent">
            A fenti feladatok ellátásához kapcsolódik még a játszóterek ellenőrzése, folyamatos karbantartása, jogszabályi előírások betartása.
          </p>

        </div>

      </div>

    </section>
  );
};

export default ActivitiesPark;